// form validation & submit

export function form() {
    // start validation rules
    const validateEmail = (email: string, input: HTMLInputElement) => {
        const re: RegExp = /\S+@\S+\.\S+/;
        if (!re.test(email)) {
            input.classList.add("error");
            return false;
        } else {
            input.classList.remove("error");
            return true;
        }
    };

    const singleText = (text: string, input: HTMLInputElement) => {
        const re: RegExp = /^[a-zA-Z0-9]+$/;
        if (!re.test(text)) {
            input.classList.add("error");
            return false;
        } else {
            input.classList.remove("error");
            return true;
        }
    };

    const validateRadio = (input: HTMLInputElement) => {
        const inputGroup = input.parentNode?.parentNode?.parentNode?.parentNode;
        const inputs = inputGroup?.querySelectorAll("input");
        const checkedInput = inputGroup?.querySelector("input:checked");
        if (checkedInput) {
            inputs?.forEach((inputElement) => {
                inputElement.classList.remove("error");
            });
            return true;
        } else {
            inputs?.forEach((inputElement) => {
                inputElement.classList.add("error");
            });
            return false;
        }
    };

    const validateCheckbox = (input: HTMLInputElement) => {
        if (input.checked) {
            input.classList.remove("error");
            return true;
        } else {
            input.classList.add("error");
            return false;
        }
    };

    const validateSelect = (input: HTMLInputElement) => {
        const errorContainer =
            input.parentNode?.parentNode?.parentNode?.querySelector(
                ".error-container",
            ) as HTMLElement;
        if (input.value) {
            errorContainer.style.display = "none";
            input.classList.remove("error");
            return true;
        } else {
            errorContainer.style.display = "block";
            input.classList.add("error");
            return false;
        }
    };

    const validateHousenr = (nr: string, input: HTMLInputElement) => {
        const re: RegExp = /^[0-9a-zA-Z\.\-\s]{1,}$/;
        if (!re.test(nr)) {
            input.classList.add("error");
            return false;
        } else {
            input.classList.remove("error");
            return true;
        }
    };

    const validatePlz = (plz: string, input: HTMLInputElement) => {
        const re: RegExp = /^[0-9]{4,}$/;
        if (!re.test(plz)) {
            input.classList.add("error");
            return false;
        } else {
            input.classList.remove("error");
            return true;
        }
    };

    const validateTel = (tel: string, input: HTMLInputElement) => {
        const re: RegExp = /^[0|+][0-9\/\-\s\+]{4,}$/;
        if (!re.test(tel)) {
            input.classList.add("error");
            return false;
        } else {
            input.classList.remove("error");
            return true;
        }
    };

    const validateAtLeastFour = (text: string, input: HTMLInputElement) => {
        if (text.length < 4) {
            input.classList.add("error");
            return false;
        } else {
            input.classList.remove("error");
            return true;
        }
    };

    const validateAtLeastSixNumbers = (
        numberString: string,
        input: HTMLInputElement,
    ) => {
        const re: RegExp = /^[0-9]+$/;
        if (!re.test(numberString)) {
            input.classList.add("error");
            return false;
        } else {
            input.classList.remove("error");
            return true;
        }
    };

    const validateMustBeInFuture = (date: string, input: HTMLInputElement) => {
        const now = new Date();
        const givenDate = new Date(date);
        now.setHours(0, 0, 0, 0);
        if (givenDate < now || date === "") {
            input.classList.add("error");
            return false;
        } else {
            input.classList.remove("error");
            return true;
        }
    };

    const validateAtLeastEighteenYearsOld = (
        date: string,
        input: HTMLInputElement,
    ) => {
        const now = new Date();
        const givenDate = new Date(date);
        now.setHours(0, 0, 0, 0);
        const todayMinusEighteenYears = new Date(
            now.setFullYear(now.getFullYear() - 18),
        );
        if (todayMinusEighteenYears < givenDate || date === "") {
            input.classList.add("error");
            return false;
        } else {
            input.classList.remove("error");
            return true;
        }
    };

    const validateText = (text: string, input: HTMLInputElement) => {
        if (text.length < 1) {
            input.classList.add("error");
            return false;
        } else {
            input.classList.remove("error");
            return true;
        }
    };

    const validatesIdCard = (text: string, input: HTMLInputElement) => {
        const re: RegExp = /^[a-zA-Z0-9]{10}$/;
        if (!re.test(text)) {
            input.classList.add("error");
            return false;
        } else {
            input.classList.remove("error");
            return true;
        }
    };

    const oneOrMore = (value: string, input: HTMLInputElement) => {
        const allInputFields =
            input.parentNode?.parentNode?.querySelectorAll<HTMLFormElement>(
                "input",
            );
        let atLeastOneOrMore = false;
        const errorWrapper =
            document.querySelector<HTMLElement>(".error-wrapper");

        allInputFields?.forEach((inputField) => {
            if (inputField.checked) {
                atLeastOneOrMore = true;
                input.classList.remove("error");
                if (errorWrapper) {
                    errorWrapper.style.display = "none";
                }
                return atLeastOneOrMore;
            }
        });

        if (!atLeastOneOrMore) {
            input.classList.add("error");
            if (errorWrapper) {
                errorWrapper.style.display = "block";
            }
        }

        return atLeastOneOrMore;
    };
    // end validation rules

    const revalidateOnInputChangeCertainFields = (fields: NodeList) => {
        fields.forEach.call(fields, function (e) {
            e.addEventListener(
                "change",
                function () {
                    validateAllFields(fields);
                },
                false,
            );
        });
    };
    const validateCertainFields = (reqInputFields: NodeList): boolean => {
        const checkIfValid: boolean[] = [];
        reqInputFields.forEach((reqInputField: Node) => {
            const input: HTMLInputElement = reqInputField as HTMLInputElement;
            const inputPlaceholder: string = input?.getAttribute(
                "placeholder",
            ) as string;

            if (inputPlaceholder === "Vorname") {
                checkIfValid.push(validateText(input.value, input));
            }

            if (inputPlaceholder === "Nachname") {
                checkIfValid.push(validateText(input.value, input));
            }
        });

        return !checkIfValid.includes(false);
    };

    // revalidate on input change
    const revalidateOnInputChange = (fields: NodeList) => {
        fields.forEach.call(fields, function (e) {
            e.addEventListener(
                "change",
                function () {
                    validateAllFields(fields);
                },
                false,
            );
            e.addEventListener(
                "changeDate",
                function () {
                    validateAllFields(fields);
                },
                false,
            );
        });
    };

    const scrollToErrorLabel = (offset: number, error: HTMLFormElement) => {
        const yOffset = -offset;
        const y = error.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
    };

    const validateAllFields = (reqInputFields: NodeList): boolean => {
        let checkIfValid: boolean[] = [];
        reqInputFields.forEach((reqInputField: Node) => {
            const input: HTMLInputElement = reqInputField as HTMLInputElement;
            const inputType: string = input?.getAttribute("type") as string;

            switch (inputType) {
                case "text":
                    checkIfValid.push(validateText(input.value, input));
                    break;
                case "radio":
                    checkIfValid.push(validateRadio(input));
                    break;
                case "checkbox":
                    checkIfValid.push(validateCheckbox(input));
                    break;
                case "email":
                    checkIfValid.push(validateEmail(input.value, input));
                    break;
                case "tel":
                    checkIfValid.push(validateTel(input.value, input));
                    break;
                /*default:
                    console.log(`No validation found for ${inputType}.`);*/
            }

            switch (input.dataset.validates) {
                case "singletext":
                    checkIfValid.push(singleText(input.value, input));
                    break;
                case "plz":
                    checkIfValid.push(validatePlz(input.value, input));
                    break;
                case "housenumber":
                    checkIfValid.push(validateHousenr(input.value, input));
                    break;
                case "must-be-in-future":
                    checkIfValid.push(
                        validateMustBeInFuture(input.value, input),
                    );
                    break;
                case "at-least-eighteen-years-old":
                    checkIfValid.push(
                        validateAtLeastEighteenYearsOld(input.value, input),
                    );
                    break;
                case "at-least-four":
                    checkIfValid.push(validateAtLeastFour(input.value, input));
                    break;
                case "at-least-six-numbers":
                    checkIfValid.push(
                        validateAtLeastSixNumbers(input.value, input),
                    );
                    break;
                case "id-card":
                    checkIfValid.push(validatesIdCard(input.value, input));
                    break;
                case "oneormore":
                    checkIfValid.push(oneOrMore(input.value, input));
                    break;
                /*default:
                    console.log(`No validation found for ${input.dataset.validates}.`);*/
            }

            if (input.nodeName.toLowerCase() === "select") {
                checkIfValid.push(validateSelect(input));
            }

            if (input.dataset.validates === "oneormore") {
                checkIfValid.push(oneOrMore(input.value, input));
                const checked = checkIfValid.some(function (e) {
                    return e;
                });
                if (checked) {
                    checkIfValid = checkIfValid.filter(Boolean);
                }
            }
        });
        return !checkIfValid.includes(false);
    };

    const forms: NodeListOf<HTMLFormElement> =
        document.querySelectorAll("form");
    if (forms.length > 0) {
        forms.forEach((form: HTMLFormElement) => {
            const iconLabels =
                document.querySelectorAll<HTMLElement>(".icon-label");
            if (iconLabels.length > 0) {
                iconLabels.forEach((iconLabel) => {
                    const input: HTMLInputElement =
                        iconLabel.lastElementChild as HTMLInputElement;
                    input.style.color = "grey";
                    iconLabel.addEventListener("click", () => {
                        input.style.color = "black";
                        input.focus();
                        input.onblur = () => {
                            input.style.color = "grey";
                        };
                        /*iconLabel.querySelector<HTMLElement>('');*/
                    });
                });
            }

            //send form on sl-select change (e.g. sortable)
            const selectFields = form.querySelectorAll(
                ".on-select-change sl-select",
            );
            if (selectFields.length > 0) {
                selectFields.forEach((selectField) => {
                    selectField.addEventListener("sl-change", () => {
                        form.submit();
                    });
                });
            }

            //send form on input change (e.g. empfohlene Angebote)
            const inputFilterFields = form.querySelectorAll(
                ".on-select-change input.filter-on-change",
            );
            if (inputFilterFields.length > 0) {
                inputFilterFields.forEach((inputField: Node) => {
                    const input = inputField as HTMLInputElement;
                    input.addEventListener("change", function () {
                        const label = input.closest("label");
                        if (label) {
                            const arrow = label.querySelector(".arrow");
                            if (arrow) {
                                if (input.checked) {
                                    arrow.classList.add("checked");
                                } else {
                                    arrow.classList.remove("checked");
                                }
                            }
                        }
                        form.submit();
                    });
                });
            }

            //on input onchange save form
            const xhrInputs = form.querySelectorAll(".xhr-form input");
            if (xhrInputs.length > 0) {
                xhrInputs.forEach((xhrInput) => {
                    xhrInput.addEventListener("change", (e) => {
                        e.preventDefault();
                        //send the form data
                        const data = new FormData(form);

                        fetch(form.action, {
                            method: "POST",
                            headers: {
                                "X-Requested-With": "XMLHttpRequest",
                            },
                            body: data,
                            cache: "default",
                            credentials: "same-origin",
                        }).then((response) => {
                            if (response.ok) {
                                // Handle successful response, e.g., form reset
                            } else {
                                // Handle error response
                                /*console.error('Error:', response.statusText);*/
                            }
                        });
                    });
                });
            }

            // singlelane form
            const radios = form.querySelectorAll<HTMLFormElement>(
                '.singlelane [type="radio"]',
            );
            if (radios.length > 0) {
                radios.forEach((radio) => {
                    // check for datePickerInQuestion
                    if (radio.getAttribute("class") !== "datepick-radio") {
                        radio.addEventListener("click", () => {
                            const datepickerSetToEmptyValue =
                                document.querySelectorAll<HTMLInputElement>(
                                    ".datepicker-opener",
                                );
                            if (datepickerSetToEmptyValue.length > 0) {
                                datepickerSetToEmptyValue.forEach(
                                    (datepicker) => {
                                        datepicker.value = "";
                                    },
                                );
                            }
                            form.submit();
                        });
                    }
                });
            }

            // make input fields required, when there is at least one character as input
            const inputFields = form.querySelectorAll(
                'input:not([required], [type="radio"]), select:not([required])',
            );
            if (inputFields.length > 0) {
                inputFields.forEach((inputField: Node) => {
                    const input = inputField as HTMLInputElement;
                    input.addEventListener("change", function () {
                        if (input && input.value) {
                            input.required = true;
                            input.classList.remove("removed-error");
                        } else {
                            input.required = false;
                            input.classList.add("removed-error");
                        }
                    });
                });
            }

            if (form.id === "advice-offers") {
                const reqButton =
                    form.querySelector<HTMLFormElement>(".required-form-btn");
                const notReqButton = form.querySelector<HTMLFormElement>(
                    ".not-required-form-btn",
                );
                const emailInput = form.querySelector<HTMLInputElement>(
                    "#required-email-input",
                );

                if (reqButton && emailInput) {
                    reqButton.addEventListener("click", (e) => {
                        e.preventDefault();
                        if (emailInput.value === "") {
                            const isValid: boolean = singleText(
                                emailInput.value,
                                emailInput,
                            );
                            if (isValid) {
                                form.submit();
                            }
                        }
                        if (emailInput.value !== "") {
                            const isValid: boolean = validateEmail(
                                emailInput.value,
                                emailInput,
                            );
                            if (isValid) {
                                form.submit();
                            }
                        }
                    });
                }
                if (notReqButton) {
                    notReqButton.addEventListener("click", () => {
                        const emailInput = form.querySelector<HTMLInputElement>(
                            "#required-email-input",
                        );
                        if (emailInput) {
                            emailInput.value = "";
                        }
                        form.submit();
                    });
                }
            }

            // standard form
            form.addEventListener("submit", (e) => {
                e.preventDefault();

                const target: HTMLFormElement = e.target as HTMLFormElement;

                // START exceptions
                // Exception, checkout form -> on "Speichern und zurueck" validate only first- and last-name
                if (target.id === "checkout-form") {
                    const button = e.submitter as HTMLFormElement;
                    if (button.id === "checkout-noval-button") {
                        const reqInputFields: NodeList =
                            target.querySelectorAll(
                                '[placeholder="Vorname"], [placeholder="Nachname"]',
                            );
                        if (reqInputFields.length < 1) {
                            form.submit();
                        } else {
                            const isItValid: boolean =
                                validateAllFields(reqInputFields);
                            if (isItValid) {
                                form.submit();
                                return;
                            } else {
                                const error =
                                    form.querySelector<HTMLFormElement>(
                                        ".error",
                                    );
                                if (error) {
                                    scrollToErrorLabel(32, error);
                                }
                                validateCertainFields(reqInputFields);
                            }
                            revalidateOnInputChangeCertainFields(
                                reqInputFields,
                            );
                            return;
                        }
                    }
                }
                // Exception, don't send form when #advice-offers (promoter send offers to buyer)
                if (target.id === "advice-offers") {
                    return;
                }
                // END exceptions

                // start validation on normal form / when inputs are set to required
                const reqInputFields: NodeList = target.querySelectorAll(
                    "input[required], select[required]",
                );
                if (reqInputFields.length < 1) {
                    form.submit();
                } else {
                    const isItValid: boolean =
                        validateAllFields(reqInputFields);
                    if (isItValid) {
                        form.submit();
                    } else {
                        const error =
                            form.querySelector<HTMLFormElement>(".error");
                        if (error) {
                            scrollToErrorLabel(32, error);
                        }
                        validateAllFields(reqInputFields);
                    }
                    revalidateOnInputChange(reqInputFields);
                }
            });
        });
    }
}
